import { defineStore } from 'pinia'
import { useAppointmentStore } from '@/Store/Appointment'
import { usePage } from '@inertiajs/inertia-vue3'
import format from 'date-fns/format';

export const useNotificationStore = defineStore('notification', {
    state: () => ({
        interval: null,
        notifications_unviewed: 0,
        notifications: [],
        total_pages: 1,
        page: 0,
        page_size: 10,
        onlyUnread: usePage().props.value.auth.user.notification_only_unread == 1,
    }),
    actions: {
        setOnlyUnread(value) {
            this.onlyUnread = value;
        },
        setNotificationsUnviewed(value) {
            this.notifications_unviewed = value;
        },
        intervalClear() {
            clearInterval(this.interval);
        },
        start() {
            if (this.interval) {
                clearInterval(this.interval);
            }
            this.loadAlerts();
            this.interval = setInterval(this.loadAlerts, 1000 * 60); // 1000ms * 60s
        },
        loadAlerts() {
            fetch(
                `/notifications/alerts`
            ).then(res => {
                res.json().then(json => {
                    const appointmentStore = useAppointmentStore();
                    this.notifications_unviewed = json.notifications_unviewed;
                    if (json.appointment && !appointmentStore.modal_appointment?.id && (!appointmentStore.appointment?.id || json.appointment.id != appointmentStore.appointment.id)) {
                        appointmentStore.setModalAppointment(json.appointment);
                    }
                    if (json.next_appointment) {
                        appointmentStore.setNextAppointment(json.next_appointment);
                    } else if (appointmentStore.next_appointment) {
                        appointmentStore.setNextAppointment(null);
                    }
                });
            });
        },
        loadNotifications() {
            let token = usePage().props.value.csrf_token;
            this.page++;
            return fetch(`/notifications`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-Token': token
                },
                body: JSON.stringify({
                    only_unread: this.onlyUnread,
                    page_size: this.page_size,
                    page: this.page,
                })
            }).then(res => {
                return res.json().then(json => {
                    this.setNotificationsUnviewed(json.notifications_unviewed);
                    if (this.page == 1) {
                        this.notifications = [];
                    }
                    this.notifications.push(...json.notifications.data);
                    this.total_pages = json.notifications.last_page;
                });
            });
        },
        reset() {
            this.notifications = [];
            this.page = 0;
            this.total_pages = 1;
        },
        markAsRead(notification) {
            fetch(
                `/notifications/mark-read/` + notification.id
            ).then(res => {
                res.json().then(json => {
                    if (this.onlyUnread) {
                        this.notifications = this.notifications.filter((n) => notification.id != n.id);
                    } else {
                        this.notifications.find(n => notification.id === n.id).read_at = format(new Date(), 'yyyy-MM-dd HH:mm');
                    }
                });
            });
        }
    },
})